import React from 'react';
import { Card, Badge, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SHIFT_COLORS, SKILLS } from '../../data/operatorConstants.js';

const skillLabelMap = Object.fromEntries(SKILLS.map(s => [s.key, s.label]));

const OperatorCard = ({ operator, onEdit, onDelete, isAdmin }) => {
  const shiftColor = SHIFT_COLORS[operator.shift] || 'secondary';

  return (
    <Card
      className={`mb-2 ${!operator.active ? 'opacity-50' : ''}`}
      style={{ fontSize: '0.875rem' }}
    >
      <Card.Body className="py-2 px-3">
        <div className="d-flex justify-content-between align-items-start">
          <div className="flex-1">
            <div className="d-flex align-items-center gap-2 mb-1">
              <strong>{operator.name}</strong>
              {!operator.active && (
                <Badge bg="secondary" className="ms-1">
                  Inactive
                </Badge>
              )}
            </div>

            {operator.skills?.length > 0 && (
              <div className="mb-1">
                {operator.skills.map(skill => (
                  <Badge
                    key={skill}
                    bg="info"
                    className="me-1 mb-1"
                    style={{ fontWeight: 'normal', fontSize: '0.75rem' }}
                  >
                    {skillLabelMap[skill] || skill}
                  </Badge>
                ))}
              </div>
            )}

            {operator.preferredMachines?.length > 0 && (
              <div>
                {operator.preferredMachines.map(machine => (
                  <Badge
                    key={machine}
                    bg={shiftColor}
                    className="me-1 mb-1"
                    style={{
                      fontWeight: 'normal',
                      fontSize: '0.7rem',
                      opacity: 0.8
                    }}
                  >
                    {machine}
                  </Badge>
                ))}
              </div>
            )}
          </div>

          {isAdmin && (
            <div className="d-flex gap-1 ms-2">
              <Button
                variant="link"
                size="sm"
                className="p-0 text-primary"
                onClick={e => {
                  e.stopPropagation();
                  onEdit(operator);
                }}
                title="Edit"
              >
                <FontAwesomeIcon icon="pen" size="sm" />
              </Button>
              <Button
                variant="link"
                size="sm"
                className="p-0 text-danger"
                onClick={e => {
                  e.stopPropagation();
                  onDelete(operator);
                }}
                title="Delete"
              >
                <FontAwesomeIcon icon="trash" size="sm" />
              </Button>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default OperatorCard;
